<template>
  <div>
    <div
      class="nav"
      :style="{ backgroundColor: common_info.header.background.color }"
    >
      <div class="w nav-box">
        <router-link
          to="/allsort"
          class="nav-all"
          :style="{ color: common_info.header.font_color }"
        >
          <div class="img-all">
            <span :style="{ color: common_info.header.font_color }"></span>
            <span :style="{ color: common_info.header.font_color }"></span>
            <span :style="{ color: common_info.header.font_color }"></span>
          </div>
          全部商品分类
          <i
            class="img-xia"
            :style="{ color: common_info.header.font_color }"
          ></i>
          <div
            class="nav_classify"
            v-if="
              routerlink != '/' &&
              routerlink != '/allsort' &&
              classList &&
              classList.length
            "
          >
            <ul
              :style="{
                border: 'solid 1px ' + common_info.header.background.color,
                borderTop: 'none',
                backgroundColor: common_info.header.background.color,
              }"
            >
              <li v-for="(item, index) in classList" :key="index">
                <div class="ttshop_navtitle">
                  <div class="ttshop-nav-icon">
                    <img
                      class="img-default"
                      :src="item.icon"
                      :onerror="error_img"
                      alt=""
                    />
                  </div>
                  <router-link
                    :to="{ path: '/list', query: { id: item.id } }"
                    v-text="item.name"
                    :style="{ color: common_info.header.font_color }"
                  ></router-link>
                </div>
                <div class="ttshop_navsecond">
                  <div class="ttshop_navsecondcon clearfloat">
                    <div class="ttshop_navsecondleft">
                      <div class="ttshop_navsecondbut">
                        <div
                          class="ttshop_navseconlist d-flex"
                          v-for="(items, index) in item.child"
                          :key="index"
                        >
                          <div class="d-flex align-items-center">
                            <router-link
                              :to="{ path: '/list', query: { id: items.id } }"
                              class="second_title"
                              v-text="items.name"
                            ></router-link>
                            <img
                              src="https://style.51caigou.com/mall/img/index/more_item.svg"
                              class="second_img"
                              alt=""
                            />
                          </div>

                          <ul
                            class="clearfloat"
                            v-if="items.child && items.child.length"
                          >
                            <li
                              v-for="(itemthree, index) in items.child"
                              :key="index"
                            >
                              <router-link
                                :to="{
                                  path: '/list',
                                  query: { id: itemthree.id },
                                }"
                                v-text="itemthree.name"
                              ></router-link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </router-link>
        <ul class="nav-list">
          <li v-for="(item, index) in common_info.header.list" :key="index">
            <!-- 本窗口 -->
            <template v-if="item.open_type == 0">
              <!-- 外部链接 -->
              <template v-if="item.page_url.indexOf('http') != -1">
                <a
                  :href="item.page_url"
                  v-text="item.title"
                  :style="{ color: common_info.header.font_color }"
                ></a>
              </template>
              <!-- 内部链接 -->
              <template v-else>
                <router-link
                  :to="item.page_url"
                  v-text="item.title"
                  :style="{ color: common_info.header.font_color }"
                ></router-link>
              </template>
            </template>
            <!-- 新窗口 -->
            <template v-else>
              <!-- 外部链接 -->
              <template v-if="item.page_url.indexOf('http') != -1">
                <a
                  :href="item.page_url"
                  target="_blank"
                  v-text="item.title"
                  :style="{ color: common_info.header.font_color }"
                ></a>
              </template>
              <!-- 内部链接 -->
              <template v-else>
                <router-link
                  :to="item.page_url"
                  target="_blank"
                  v-text="item.title"
                  :style="{ color: common_info.header.font_color }"
                ></router-link>
              </template>
            </template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      common_info: {
        header: {
          background: {},
        },
      },
      routerlink: this.$route.path,
	  classList:[],
	  error_img:
        'this.src="' + require("../../assets/images/lodingsb.svg") + '"', //图片加载失败
    
    };
  },

  
  created() {
    this.common.getCommonInfo(this);
    if (this.$route.path == "/allsort"||this.$route.path == "/list") {
      this.classification();
    }
  },
  methods: {
    flushCom() {
      this.$router.go(0);
    },
    classification() {
      let that = this;
      this.$api
        .getClassify()
        .then((res) => {
          if (res.code == 0) {
            that.classList = res.data;
          }
        })
        .catch((err) => {});
    //   console.log(this.classList);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  position: relative;
  height: 40px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1);

  .nav-box {
    display: flex;
    height: 40px;
    // align-items: center;
    line-height: 40px;

    .nav-all {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      width: 190px;
      padding-left: 20px;
      box-sizing: border-box;
      position: relative;
	  &:hover {
       
        .nav_classify {
          display: block;
        }
      }
      .img-all {
        width: 14px;
        height: 12px;
        margin-right: 8px;
        vertical-align: middle;

        span {
          display: block;
          margin-top: 3px;
        }

        span:after {
          content: "";
          display: block;
          width: 14px;
          height: 0;
          border-top: 2px solid;
        }

        span:first-child {
          margin-top: 0;
        }
      }

      .img-xia {
        /* width: 9px;
					height: 6px;
					margin-left: 4px;
					vertical-align: middle; */
        content: "";
        width: 0;
        height: 0;
        margin-left: 4px;
        border-top: 4px solid;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
      }
    }

    .nav-list {
      display: flex;
      font-weight: 600;
      margin-left: 34px;
      flex-wrap: wrap;
      overflow: hidden;
      flex: 1;

      li {
        margin-right: 40px;

        a {
          font-size: 16px;
          color: #333;
          font-weight: 600;
          display: block;
          cursor: pointer;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;

          &:hover {
            color: #ff0e25;
          }
        }
      }

      li:last-child {
        margin-right: 0;
      }
    }
  }
}
.nav_classify {
  position: absolute;
  top: 40px;
  left: 0;
  width: 190px;
  height: auto;
  box-sizing: border-box;
  // position: relative;
  display: none;
  z-index: 999;
  background: #fff;
  &:hover {
    .nav-box {
      opacity: 0.8;
    }
  }
  & > ul {
    padding: 16px 0;
    box-shadow: 0 2px 6px -1px rgb(0 0 0 / 20%);
  }
  li {
    width: 100%;

    .ttshop_navtitle {
      position: relative;
      width: 100%;
      box-sizing: border-box;
      height: 40.6px;
      line-height: 40.6px;
      padding-left: 37px;
      cursor: pointer;

      .ttshop-nav-icon {
        width: 16px;
        height: 16px;
        float: left;
        position: absolute;
        left: 12px;
        top: 12.3px;
      }

      a {
        font-size: 14px;
        color: #333;
        cursor: pointer;
        position: relative;
        margin-right: 6px;
        transition: all 0.4s;
        font-weight: 400;
        overflow: hidden;
        float: left;
        max-height: 40.6px;

        &::before {
          content: "/";
          font-size: 12px;
          color: #333;
          position: absolute;
          top: -1px;
          right: -6px;
          line-height: 1.5;
        }
        &:last-child::before {
          display: none;
        }
      }

      &:hover {
        // box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
        background-color: rgba(0, 0, 0, 0.05);
      }
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
      .ttshop_navsecond {
        display: block;
      }
      .ttshop_navsecond
        .ttshop_navsecondcon
        .ttshop_navsecondleft
        .ttshop_navsecondbut
        .ttshop_navseconlist
        ul
        li
        a {
        background-color: #fff;
      }
    }

    .ttshop_navsecond {
      display: none;
      position: absolute;
      top: 0px;
      left: 190px;
      // width: 1000px;
      width: 782px;
      min-height: 480px;
      padding: 18px 24px;
      box-sizing: border-box;
      background: #fff;
      z-index: 1000;
      // box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
      border: solid 1px #f5f5f5;
      border-top: none;
      max-height: 480px;
      .ttshop_navsecondcon {
        width: 100%;
        max-height: 454px;
        overflow-y: scroll;
        // &::-webkit-scrollbar {
        //   display: none;
        // }
        .ttshop_navsecondleft {
          float: left;

          .ttshop_navseconduptitle {
            width: 100%;
            margin-bottom: 20px;

            span {
              float: left;
              font-size: 12px;
              color: #ff0e25;
              background: #fff0f1;
              padding: 6px 12px;
              line-height: 12px;
              box-sizing: border-box;
              margin-right: 16px;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;
              cursor: pointer;
              border-radius: 2px;

              &:last-child {
                margin-right: 0;
              }

              &:hover {
                background: #ff0e25;
                color: #fff;
              }
            }
          }

          .ttshop_navsecondbut {
            width: 100%;

            .ttshop_navseconlist {
              width: 100%;
              align-items: flex-start;

              &:last-child {
                margin-bottom: 0;
              }

              a {
                float: left;
                width: 78px;
                padding: 12px 10px 12px 0;
                font-size: 14px;
                line-height: 20px;
                color: #333;
                // font-weight: 600;
                transition: 0.5s;
                -moz-transition: 0.5s;
                -webkit-transition: 0.5s;
                -o-transition: 0.5s;
                cursor: pointer;
                text-align: left;

                &:hover {
                  color: #ff0e25;
                }
              }
              .second_img {
                margin-left: 4px;
                width: 9px;
                // height: auto;
                height: 14px;
              }
              .second_title {
                text-align: right;
              }

              ul {
                float: left;
                // width: 636px;
                width: 610px;
                padding: 6px 0 12px;
                border-bottom: 1px solid #f5f5f5;
                margin-left: 15px;

                li {
                  width: auto;
                  float: left;
                  margin: 8px 20px 0 0;
                  line-height: normal;

                  a {
                    float: none;
                    width: auto;
                    padding: 0;
                    font-size: 14px;
                    line-height: 16px;
                    color: #999;
                    font-weight: 400;
                    transition: 0.5s;
                    -moz-transition: 0.5s;
                    -webkit-transition: 0.5s;
                    -o-transition: 0.5s;

                    &:hover {
                      color: #ff0e25;
                      font-weight: 500;
                    }
                  }
                }
                li:last-child {
                  margin-right: 0;
                }
              }
            }
          }
        }

        .ttshop_navsecondright {
          float: right;
          width: 218px;

          .ttshop_navbutton {
            width: 100%;

            .ttshop_navbuttonlist {
              width: 100%;
              height: 108px;
              cursor: pointer;

              &:last-child {
                margin-bottom: 0;
              }

              img {
                width: 100%;
                display: block;
              }
            }
          }
        }
      }
    }
  }

  .nav-box {
    width: 800px;
    height: 480px;
    background: #ebebeb;
    position: absolute;
    left: 190px;
    top: 0;
    z-index: 10;
    opacity: 0;
    transition: 0.35s;
    -moz-transition: 0.35s;
    -webkit-transition: 0.35s;
    -o-transition: 0.35s;
  }
}
</style>
